import { AttractionThemesList } from '@/components/attractions/themes/AttractionThemesList';
import { useParams } from 'react-router-dom';

export function AttractionThemesTab() {
  const { id } = useParams<{ id: string }>();

  if (!id) return null;

  return <AttractionThemesList attractionId={id} className="p-0" />;
}
